// import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
// import { Modal,Container, Row, Col, Table,Button } from "react-bootstrap";
// import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; 
// import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions"; 
// import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; 
// import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik"; 
// import MasterService from "../../Services/MasterService"; import { IoIosReturnLeft } from "react-icons/io"; import Select from 'react-select';
// import { IoReturnDownBack, IoReturnDownForward } from "react-icons/io5";  import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa";

// export default function IndicatorwisemappingReport() {
//   const { showAlert, alertData,showAlertMessage, closeAlert } = useAlert(); 
//   const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); 
//   const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState(); const [searchText, setSearch] = useState("");
//   const[maintablenb,setmaintablenb]=useState(false);
//   const [loading, setLoading] = useState(false);
//   const [selecteddist,setselecteddist]=useState("");
//   const [selecteddistId,setselecteddistId]=useState("");
//   const [selectedmandal,setselectedmandal]=useState("");
//   const [yearList,setYearList] = useState([]);
//   const [monthList, setMonthList] = useState([]);
// const [remarksStatus, setRemarksStatus] = useState({}); const [criteriaData, setCriteriaData] = useState([]); const [remarksData, setRemarksData] = useState([]);
// const [remarksText, setRemarksText] = useState({}); const [mandalSummary, setMandalSummary] = useState([]); const [selectedMandalId, setSelectedMandalId] = useState(null); const [allAcceptance, setAllAcceptance] = useState("");
// const [statusCode, setStatusCode] = useState(""); const [statusId, setStatusId] = useState(null); const [mandalList, setMandalList] = useState([]); const [formikMandalId, setformikMandalId] = useState("");
// const [data, setData] = useState([])
//   let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); let username = localStorage.getItem("username"); 
//   let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid"); let roleid = localStorage.getItem("catid"); let mainroleid = localStorage.getItem("role");
//   let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbid":"mandalid"); const [showDetailTable, setShowDetailTable] = useState( ["111", "117"].includes(roleid) );

//   const formik = useFormik({
//     initialValues: { department_id:"", district_id:"",year:"",  month: "",type:"",mandal_id:""},
//   });



  

//   useEffect(() => {
//     datetime(setcurrentdate, setcurrenttime);
//     let params = { userId: username }
//     MasterService.getAllDepts(params).then((res) => { 
//       if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); 
//       setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
//     MasterService.getindicatorAcceptanceYear().then((achievvalueres) => { if (achievvalueres.data) { 
//       let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
//                setYearList(achievvalueres.data); } });
//     MasterService.getkpiMonths(params).then((res) => { if (res.data && res.data.SCODE === "01") { setMonthList(res.data.SDESC || []); } 
//       else { setMonthList([]); } });
//     MasterService.getDistricts().then((res17) => { if (res17.data) { 
//       let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); }); 
//        setDistrictList([
//       { id: "0", value: "All" },  
//       ...(res17.data || [])
//     ]); } });
//       const distId = localStorage.getItem("districtid");
//       formik.setFieldValue("district_id",distId)
//        if (roleid === "119") {  MandalData(distId); }
//      if(["113","119","117","111"].includes(roleid)){setselecteddist(localStorage.getItem("districtname"))
       
//      }
//      if(["117","111"].includes(roleid)){setselectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbname":"mandalname"))}
//      if(["111","113","114","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); }
//      if(["113","114","111","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); formik.setFieldValue("district_id",district); }
//      if(["119","117"].includes(roleid)){ formik.setFieldValue("district_id",district); } 
//      if (roleid === "117") { formik.setFieldValue("type", 0);  Planning(0,district, mandalid); }
    
     
//     }, []);

 
//   const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white",wordBreak: "break-word" };
// let typeOptions = [];
// if (roleid === "117") {
//   typeOptions = [{ id: 0, value: "Mandal" }];
// }
// // else if(roleid === "119" && formik.values.mandal_id!=="0"){
// //     typeOptions = [{ id: 1, value: "District" }];

// // }
//  else {
//   typeOptions = [
//     { id: 0, value: "Mandal" },
//     { id: 1, value: "District" }
//   ];
// }



// const MandalData=(id)=>{

//   setselecteddistId(id)
//   let params = { district_id: id };
//       MasterService.getMandals(params).then((res) => {
//         if (res.data) {
//           let options = res.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
//           setMandalList([ { id: "0", value: "All" }, ...(res.data?? []) ]);
//         }
//         else{setMandalList([])}
      
// })}

// const Planning = (type, dist, mandal, year) => {
//   const selectedType = Number(type);
// if(!year){
//   return
// }
//   setmaintablenb(false);
//   setLoading(true);

//   if (selectedType === 0) {
//     let payload = {
//       userId: username,
//       districtId: dist,
//       mandalId:
//         roleid === "119" || roleid === "116"
//           ? mandal
//           : mandalid,
//       finYear: year,
//     };

//     KpiService.mandalMapIndicatorReport(payload)
//       .then((res) => {
//         setData(res.data?.dataList || []);
//       })
//       .catch(() => {
//         setData([]);
//       })
//       .finally(() => {
//         setLoading(false);
//         setmaintablenb(true);
//       });

//   } else {
//     let params = {
//       userId: username,
//       districtId: dist,
//       finYear: year,
//     };

//     KpiService.districtMapIndicatorReport(params)
//       .then((res) => {
//         setData(res.data?.dataList || []);
//       })
//       .catch(() => {
//         setData([]);
//       })
//       .finally(() => {
//         setLoading(false);
//         setmaintablenb(true);
//       });
//   }
// };
//               const filteredData = searchText.length > 0 && data?.length ? data.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText.toLowerCase()) ); }) ); }) : data;

//   return (
//     <>
//       <Menubar />
//       <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>Indicators Performance Mapping 
//             <span> Acceptance Entry Report </span> </h2> </div> </Container>
     
//       <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
//         <FormikProvider value={formik}>
//                   <Form onSubmit={formik.handleSubmit}>
//                     <div className="py-2 px-4 mb-3">
//                       <Row>
//                         <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
//                         <label className="mb-1 fw-bold">Level</label> 
   

// <Select
//   className="w-100"
//   isClearable={true}
//   isSearchable={true}
//   name="type"
//   required={true}
//   getOptionValue={(option) => option.id}
//   getOptionLabel={(option) => option.value}
//   options={[
//     { id: 0, value: "Mandal" },
//     { id: 1, value: "District" }
//   ]}
// // options={typeOptions}
//   isDisabled={roleid === "117"} 

//   value={
//     [
//       { id: 0, value: "Mandal" },
//       { id: 1, value: "District" }
//     ].find((option) => option.id === formik.values?.type) || null
//   }
//   onChange={(option) => {
//     if(roleid==="116" ){formik.setFieldValue("district_id","");formik.setFieldValue("mandal_id","");formik.setFieldValue("year",""); setMandalList([]) }
//      if(roleid==="119" ){formik.setFieldValue("mandal_id","");formik.setFieldValue("year","");  }
//     if(roleid==="119" && option?.id===1) {  Planning(option?.id,selecteddistId,"0",formik.values.year);}
//     // if(roleid==="117" && option?.id===0) {  formik.setFieldValue("district_id",district);Planning(option?.id,mandalid,formik.values.year);}
//     formik.setFieldValue("type", option ? option.id : "");
//     setmaintablenb(false);
//   }}
//   menuPortalTarget={document.body}
//   styles={{
//     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//   }}
// />
//                        </Col> 
                         
//                          {["113","119","117","111","116"].includes(roleid) &&  (formik.values.type === 1 || formik.values.type === 0) && (
//                          <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> 
//                           <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, 
//                              isDisabled: roleid === "117" ? true : roleid === "116" ? false : true,
//                         extraOnChange: (option) => { setselecteddistId(option?.id); MandalData(option?.id||null); formik.setFieldValue("mandal_id",""); 
//                             if(roleid==="116" && formik.values.type===1){  Planning(formik.values.type,option?.id,"0",formik.values.year)}
                            
//                              setmaintablenb(false); } 
//                             })}
//                         /> </Col>) } 
//                         {["117"].includes(roleid) && formik.values.type === 0 && (
//                         <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
//                         <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111"?deptId:formik.values.department_id)?"ULB":"Mandal"}</label> 
//                         <Field className="mb-3 form-control" name="mandal_id" type="text"  value={selectedmandal}  controlId="formBasicEmail" 
//                         disabled={true} style={{ fontWeight: "bold" }}/> </Col> )} 

//                         {["119","116"].includes(roleid) &&  formik.values.type === 0 && (
//                         <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
//                         <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111"?deptId:formik.values.department_id)?"ULB":"Mandal"}</label> 
//                        <Select className="w-100" isClearable={true} isSearchable={true} name="mandal_id" required={true} getOptionValue={(option) => option.id} getOptionLabel={(option) => option.value} options={mandalList} value={mandalList.find((option) => option.id === formik.values?.mandal_id) || null} 
//                onChange={(option) => {    const selectedMandal = option ? option.id : ""; formik.setFieldValue("mandal_id", selectedMandal);   
//                       Planning(formik.values.type,selecteddistId, option ? option.id : "", formik.values.year);}}
           
//   menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), }}
// />
//                        </Col> )} 

//                               <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">Financial Year</label>
//                     <Select
//                       {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik,
//                         extraOnChange: (option) => { Planning(formik.values.type, formik.values.district_id, formik.values.mandal_id, option?.id) } })}
//                     /> </Col>
                       
                        
//                       </Row> </div> </Form> </FormikProvider>


//         {loading ? (
//   <div className="text-center my-4">
//     <div className="spinner-border text-success" />
//   </div>
// ) : (
//   maintablenb && (
//     <>
        
//            <Row>
//           <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
//             <div style={{ alignItems: "center",display: "flex",  border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
//               <AiOutlineSearch className="me-2" style={{ color: "#888", fontSize: "1.2rem", visibility: "visible" }} />
//               <input type="text" value={searchText} placeholder="Search"   
//               onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }}
//               onChange={(e) => setSearch(e.target.value)}onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
//             </div>
//           </Col>
//           <Col className=" mb-2 " > 
//              <button type="button" variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Indicators Performance Mapping Acceptancy Entry Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
//          </Col>
         

 
//         </Row>
//         <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
//           <span className="style">  Indicators Performance Mapping Acceptance Entry Report</span>
// {["119","116"].includes(roleid) && ( <div style={{ fontWeight: "bold", marginTop: "5px" }}>
//     {formik.values.type === 1 ? ( <> District: { distlist.find(m => m.id === formik.values.district_id)?.value || "-" } </>
//     ) : ( <> District: { distlist.find(m => m.id === formik.values.district_id)?.value || "-" } &nbsp;&nbsp;
//      Mandal: { mandalList.find(m => m.id === formik.values.mandal_id)?.value || "-" } </> )}

//   </div> )}   
//        {selectedmandal && ( <div style={{ fontWeight: "bold", marginTop: "5px" }}> District: {selecteddist}&nbsp;&nbsp;  Mandal: {selectedmandal} </div> )}
//             {/* {statusCode && ["111", "117"].includes(roleid) && ( <div style={{ marginTop: "5px", color: "#2f4f4f", fontWeight: "500" }}> Status: {statusCode} </div>
//   )} */}
         
//         </div>

//         <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
//             <Table bordered id="my-table" className="custom-table table table-bordered sticky-table">
                
         
//                       <thead>

//                          {/* <tr className="text-center only-export"> 

//                              <th colSpan="10" style={{ fontWeight: "bold", textAlign: "center" }}>
//      <span className="style">Indicators Performance Mapping Acceptance Entry Report</span> <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
//     </th>
//                              */}
//                             {/* <th colSpan={(selectedmandal === "all" && selecteddept !== "0") ? filteredDepartments.length * 3 + 2 : filteredMandals.length * 3 + 2} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}> <span className="style">  {" "} {ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"} Level Progress Report Of Year {selectedyear}</span> </th></tr>
//                   <tr className="text-center only-export"> <th colSpan={(selectedmandal === "all" && selecteddept !== "0") ? filteredDepartments.length * 3 + 2 : filteredMandals.length * 3 + 2} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
//                     {selecteddept !== "0" && <><span style={{ color: "black" }}>HOD Name:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Deptname},</span></>} <span style={{ color: "black" }}>District:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Distname}</span> {selectedmandal !== "all" && <><span style={{ color: "black" }}>&nbsp;{ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"}:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Mandalname},</span></>}
//                     <span style={{ color: "black" }}> &nbsp;Periodicity:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedperiodicity}</span> {selectedcategory && <><span style={{ color: "black" }}> ,&nbsp;Category:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedcategory}</span></>}
//                   </th></tr> <tr className="only-export"><th colSpan={(selectedmandal === "all" && selecteddept !== "0") ? filteredDepartments.length * 3 + 2 : filteredMandals.length * 3 + 2}><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr> </>}
//   */}
//                          {/* </tr> */}


//   <tr className="text-center only-export"> 
//                             <th colSpan="10" style={{ fontWeight: "bold", textAlign: "center" }}>
//      <span className="style">Indicators Performance Mapping Acceptance Entry Report</span> <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
//     </th>
//           </tr>
//          <tr className="text-center only-export"> 

//     <th colSpan="10" style={{ textAlign: "center", fontWeight: "bold" }}>
//       {["119","116"].includes(roleid) ? (
//         formik.values.type === 1 ? (
//           <>
//             District: {distlist.find(m => m.id === formik.values.district_id)?.value || "-"}
//           </>
//         ) : (
//           <>
//             District: {distlist.find(m => m.id === formik.values.district_id)?.value || "-"}
//             &nbsp;&nbsp; | &nbsp;&nbsp; 
//             Mandal: {mandalList.find(m => m.id === formik.values.mandal_id)?.value || "-"}
//           </>
//         )
//       ) : selectedmandal ? (
//         <>
//           District: {selecteddist} &nbsp;&nbsp; | &nbsp;&nbsp; Mandal: {selectedmandal}
//         </>
//       ) : null}
//     </th>
//   </tr>

//                         <tr className="text-center">
//                           <th style={{headerStyle, width: "100px"}} >Sl.No.</th>
//                           {["116"].includes(roleid) &&  formik.values.district_id==="0"  && (  
//                              <th style={{headerStyle, width: "100px"}} >District</th>)}
//                           {["119","116"].includes(roleid) &&  formik.values.mandal_id==="0" &&  formik.values.type===0 && (  
//                              <th style={{headerStyle, width: "100px"}} >Mandal</th>)}
//                           <th style={{headerStyle, width: "200px"}} >Indicator Type</th>
//                         <th style={{ ...headerStyle, width: "200px" }} > Indicator </th>
//                           {/* <th style={{headerStyle , width: "300px" }} >Targets</th>

//                           <th style={headerStyle} >Contribution (%)</th> */}
//                         </tr>

                        
//                       </thead>

       
// <tbody>
//   {filteredData?.length === 0 || filteredData?.length === undefined ? (
//     <tr>
//       <td className="text-center" colSpan="15">
//         <b style={{ color: "red" }}>Details Not Found</b>
//       </td>
//     </tr>
//   ) : (
//     (() => {
//       let mandalTracker = {};
//      let districtTracker = {};

//       return filteredData.map((detail, i) => {
//         const mandal = detail.mandal_name;
//         const district = detail.district_name;

//         if (!districtTracker[district]) {
//           let count = 0;

//           for (let j = i; j < filteredData.length; j++) {
//             if (filteredData[j].district_name === district) count++;
//             else break;
//           }

//           districtTracker[district] = {
//             count,
//             rendered: false
//           };
//         }


//         if (!mandalTracker[mandal]) {
//           let count = 0;

//           for (let j = i; j < filteredData.length; j++) {
//             if (filteredData[j].mandal_name === mandal) count++;
//             else break;
//           }

//           mandalTracker[mandal] = {
//             count,
//             rendered: false
//           };
//         }

//         return (
//           <tr key={i}>
//             <td style={{ textAlign: "center" }}>{i + 1}</td>
//                {["116"].includes(roleid) &&
//               formik.values.district_id === "0" &&
//               !districtTracker[district].rendered && (
//                 <td
//                   rowSpan={districtTracker[district].count}
//                   style={{ textAlign: "left", verticalAlign: "top" }}
//                 >
//                   {district}
//                 </td>
//               )}

//             {districtTracker[district].rendered = true}


//             {["119", "116"].includes(roleid) && formik.values.mandal_id === "0" && formik.values.type === 0 &&
//               !mandalTracker[mandal].rendered && (
//                 <td
//                   rowSpan={mandalTracker[mandal].count}
//                   style={{ textAlign: "left", verticalAlign: "top" }}
//                 >
//                   {mandal}
//                 </td>
//               )}

//             {mandalTracker[mandal].rendered = true}

//             <td style={{ textAlign: "left" }}>
//               {detail.cs_indicator_type}
//             </td>

//             <td style={{ textAlign: "left", width: "350px" }}>
//               {detail.cs_indicator_name}
//             </td>
//               {/* <td style={{textAlign:"right"}}>{detail.targets}</td> 
//               <td style={{textAlign:"right"}}>{detail.contribution_percentage}</td>  */}
//           </tr> ); }); })() )}
  
//   </tbody>

//         </Table>
       
//         </div> </div> </>
//   )
// )}

   

     



    


//        </Container>
               
//       <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
//     </>
//   );
// }


import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
import { Modal,Container, Row, Col, Table,Button } from "react-bootstrap";
import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; 
import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions"; 
import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; 
import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik"; 
import MasterService from "../../Services/MasterService"; import { IoIosReturnLeft } from "react-icons/io"; import Select from 'react-select';
import { IoReturnDownBack, IoReturnDownForward } from "react-icons/io5";  import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa";

export default function IndicatorwisemappingReport() {
  const { showAlert, alertData,showAlertMessage, closeAlert } = useAlert(); 
  const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); 
  const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState(); const [searchText, setSearch] = useState("");
  const[maintablenb,setmaintablenb]=useState(false);
  const [loading, setLoading] = useState(false);
  const [selecteddist,setselecteddist]=useState("");
  const [selecteddistId,setselecteddistId]=useState("");
  const [selectedmandal,setselectedmandal]=useState("");
  const [yearList,setYearList] = useState([]);
  const [monthList, setMonthList] = useState([]);
const [remarksStatus, setRemarksStatus] = useState({}); const [criteriaData, setCriteriaData] = useState([]); const [remarksData, setRemarksData] = useState([]);
const [remarksText, setRemarksText] = useState({}); const [mandalSummary, setMandalSummary] = useState([]); const [selectedMandalId, setSelectedMandalId] = useState(null); const [allAcceptance, setAllAcceptance] = useState("");
const [statusCode, setStatusCode] = useState(""); const [statusId, setStatusId] = useState(null); const [mandalList, setMandalList] = useState([]); const [formikMandalId, setformikMandalId] = useState("");
const [data, setData] = useState([])
  let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); let username = localStorage.getItem("username"); 
  let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid"); let roleid = localStorage.getItem("catid"); let mainroleid = localStorage.getItem("role");
  let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbid":"mandalid"); const [showDetailTable, setShowDetailTable] = useState( ["111", "117"].includes(roleid) );

  const formik = useFormik({
    initialValues: { department_id:"", district_id:"",year:"",  month: "",type:"",mandal_id:""},
  });



  

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
    let params = { userId: username }
    MasterService.getAllDepts(params).then((res) => { 
      if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); 
      setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
    MasterService.getindicatorAcceptanceYear().then((achievvalueres) => { if (achievvalueres.data) { 
      let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
               setYearList(achievvalueres.data); } });
    MasterService.getkpiMonths(params).then((res) => { if (res.data && res.data.SCODE === "01") { setMonthList(res.data.SDESC || []); } 
      else { setMonthList([]); } });
    MasterService.getDistricts().then((res17) => { if (res17.data) { 
      let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); }); 
       setDistrictList([
      { id: "0", value: "All" },  
      ...(res17.data || [])
    ]); } });
      const distId = localStorage.getItem("districtid");
      formik.setFieldValue("district_id",distId)
       if (roleid === "119") {  MandalData(distId); }
     if(["113","119","117","111"].includes(roleid)){setselecteddist(localStorage.getItem("districtname"))
       
     }
     if(["117","111"].includes(roleid)){setselectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbname":"mandalname"))}
     if(["111","113","114","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); }
     if(["113","114","111","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); formik.setFieldValue("district_id",district); }
     if(["119","117"].includes(roleid)){ formik.setFieldValue("district_id",district); } 
     if (roleid === "117") { formik.setFieldValue("type", 0); 
      //  Planning(0,district, mandalid); 
      }
    
     
    }, []);

 
  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white",wordBreak: "break-word" };
let typeOptions = [];
if (roleid === "117") {
  typeOptions = [{ id: 0, value: "Mandal" }];
}
// else if(roleid === "119" && formik.values.mandal_id!=="0"){
//     typeOptions = [{ id: 1, value: "District" }];

// }
 else {
  typeOptions = [
    { id: 0, value: "Mandal" },
    { id: 1, value: "District" }
  ];
}



const MandalData=(id)=>{

  setselecteddistId(id)
  let params = { district_id: id };
      MasterService.getMandals(params).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
          setMandalList([ { id: "0", value: "All" }, ...(res.data?? []) ]);
        }
        else{setMandalList([])}
      
})}

const Planning = (type,dist,mandal,year) => {
  const selectedType = Number(type);

  setmaintablenb(false);
  setLoading(true);

  if (selectedType === 0) {
    let payload = {
      userId: username,
    //   districtId:roleid==="117" ? district:selecteddistId,
    finYear: year,
    districtId:dist,
      mandalId: (roleid==="119" || roleid==="116")? mandal:mandalid,
    };

    KpiService.mandalMapIndicatorReport(payload)
      .then((res) => {
        setData(res.data?.dataList ||[]);
      })
      .catch(() => {
        setData([]);
      })
      .finally(() => {
        setLoading(false);
        setmaintablenb(true);
      });
  } else {
    let params = {
      userId: username,
      finYear: year,
    //   districtId: selecteddistId,
    districtId:dist,
    };

    KpiService.districtMapIndicatorReport(params)
      .then((res) => {
        setData(res.data?.dataList || []);
      })
      .catch(() => {
        setData([]);
      })
      .finally(() => {
        setLoading(false);
        setmaintablenb(true);
      });
  }
};
              const filteredData = searchText.length > 0 && data?.length ? data.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText.toLowerCase()) ); }) ); }) : data;

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>Indicators Performance Mapping 
            <span> Acceptance Entry Report </span> </h2> </div> </Container>
     
      <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="py-2 px-4 mb-3">
                      <Row>
                        <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
                        <label className="mb-1 fw-bold">Level</label> 
   

<Select
  className="w-100"
  isClearable={true}
  isSearchable={true}
  name="type"
  required={true}
  getOptionValue={(option) => option.id}
  getOptionLabel={(option) => option.value}
  options={[
    { id: 0, value: "Mandal" },
    { id: 1, value: "District" }
  ]}
// options={typeOptions}
  isDisabled={roleid === "117"} 

  value={
    [
      { id: 0, value: "Mandal" },
      { id: 1, value: "District" }
    ].find((option) => option.id === formik.values?.type) || null
  }
  onChange={(option) => {
    if(roleid==="116" ){formik.setFieldValue("district_id","");formik.setFieldValue("mandal_id",""); formik.setFieldValue("year",""); setMandalList([]) }
     if(roleid==="119" ){formik.setFieldValue("mandal_id",""); formik.setFieldValue("year",""); }
    // if(roleid==="119" && option?.id===1) {  Planning(option?.id,selecteddistId,"0");}
    // if(roleid==="117" && option?.id===0) {  formik.setFieldValue("district_id",district);Planning(option?.id,mandalid);}
    formik.setFieldValue("type", option ? option.id : "");
    setmaintablenb(false);
  }}
  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  }}
/>
                       </Col> 
                         
                         {["113","119","117","111","116"].includes(roleid) &&  (formik.values.type === 1 || formik.values.type === 0) && (
                         <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> 
                          <Select 
                          {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, 
                             isDisabled: roleid === "117" ? true : roleid === "116" ? false : true,
                        extraOnChange: (option) => { setselecteddistId(option?.id); MandalData(option?.id||null); formik.setFieldValue("mandal_id",""); 
                            // if(roleid==="116" && formik.values.type===1){  Planning(formik.values.type,option?.id,"0")}
                            formik.setFieldValue("year",""); 
                             setmaintablenb(false); } 
                            })}
                        /> </Col>) } 
                        {["117"].includes(roleid) && formik.values.type === 0 && (
                        <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
                        <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111"?deptId:formik.values.department_id)?"ULB":"Mandal"}</label> 
                        <Field className="mb-3 form-control" name="mandal_id" type="text"  value={selectedmandal}  controlId="formBasicEmail" 
                        disabled={true} style={{ fontWeight: "bold" }}/> </Col> )} 

                        {["119","116"].includes(roleid) &&  formik.values.type === 0 && (
                        <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
                        <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111"?deptId:formik.values.department_id)?"ULB":"Mandal"}</label> 
                       <Select className="w-100" isClearable={true} isSearchable={true} name="mandal_id" required={true} getOptionValue={(option) => option.id} getOptionLabel={(option) => option.value} options={mandalList} value={mandalList.find((option) => option.id === formik.values?.mandal_id) || null} 
               onChange={(option) => {    const selectedMandal = option ? option.id : ""; formik.setFieldValue("mandal_id", selectedMandal); formik.setFieldValue("year","");   
                      // Planning(formik.values.type,selecteddistId, option ? option.id : "");
                       setmaintablenb(false);
                    }}
           
  menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), }}
/>
                       </Col> )} 

                              <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">Financial Year</label>
                    <Select
                      {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik,
                        extraOnChange: (option) => { 
                          if((roleid==="116" ||roleid==="119" )&& (formik.values.type===1) || (formik.values.type===0 && formik.values.mandal_id ) || roleid==="117" ){
                          Planning(formik.values.type, formik.values.district_id, formik.values.typo, option?.id) }} })}
                    /> </Col>
                       
                        
                      </Row> </div> </Form> </FormikProvider>


        {loading ? (
  <div className="text-center my-4">
    <div className="spinner-border text-success" />
  </div>
) : (
  maintablenb && (
    <>
        
           <Row>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            <div style={{ alignItems: "center",display: "flex",  border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
              <AiOutlineSearch className="me-2" style={{ color: "#888", fontSize: "1.2rem", visibility: "visible" }} />
              <input type="text" value={searchText} placeholder="Search"   
              onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }}
              onChange={(e) => setSearch(e.target.value)}onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div>
          </Col>
          <Col className=" mb-2 " > 
             <button type="button" variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Indicators Performance Mapping Acceptancy Entry Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
         </Col>
         

 
        </Row>
        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
          <span className="style">  Indicators Performance Mapping Acceptance Entry Report</span>
{["119","116"].includes(roleid) && ( <div style={{ fontWeight: "bold", marginTop: "5px" }}>
    {formik.values.type === 1 ? ( <> District: { distlist.find(m => m.id === formik.values.district_id)?.value || "-" } </>
    ) : ( <> District: { distlist.find(m => m.id === formik.values.district_id)?.value || "-" } &nbsp;&nbsp;
     Mandal: { mandalList.find(m => m.id === formik.values.mandal_id)?.value || "-" } </> )}

  </div> )}   
       {selectedmandal && ( <div style={{ fontWeight: "bold", marginTop: "5px" }}> District: {selecteddist}&nbsp;&nbsp;  Mandal: {selectedmandal} </div> )}
            {/* {statusCode && ["111", "117"].includes(roleid) && ( <div style={{ marginTop: "5px", color: "#2f4f4f", fontWeight: "500" }}> Status: {statusCode} </div>
  )} */}
         
        </div>

        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
            <Table bordered id="my-table" className="custom-table table table-bordered sticky-table">
                
         
                      <thead>

                         {/* <tr className="text-center only-export"> 

                             <th colSpan="10" style={{ fontWeight: "bold", textAlign: "center" }}>
     <span className="style">Indicators Performance Mapping Acceptance Entry Report</span> <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
    </th>
                             */}
                            {/* <th colSpan={(selectedmandal === "all" && selecteddept !== "0") ? filteredDepartments.length * 3 + 2 : filteredMandals.length * 3 + 2} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}> <span className="style">  {" "} {ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"} Level Progress Report Of Year {selectedyear}</span> </th></tr>
                  <tr className="text-center only-export"> <th colSpan={(selectedmandal === "all" && selecteddept !== "0") ? filteredDepartments.length * 3 + 2 : filteredMandals.length * 3 + 2} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                    {selecteddept !== "0" && <><span style={{ color: "black" }}>HOD Name:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Deptname},</span></>} <span style={{ color: "black" }}>District:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Distname}</span> {selectedmandal !== "all" && <><span style={{ color: "black" }}>&nbsp;{ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"}:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Mandalname},</span></>}
                    <span style={{ color: "black" }}> &nbsp;Periodicity:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedperiodicity}</span> {selectedcategory && <><span style={{ color: "black" }}> ,&nbsp;Category:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedcategory}</span></>}
                  </th></tr> <tr className="only-export"><th colSpan={(selectedmandal === "all" && selecteddept !== "0") ? filteredDepartments.length * 3 + 2 : filteredMandals.length * 3 + 2}><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr> </>}
  */}
                         {/* </tr> */}


  <tr className="text-center only-export"> 
                            <th colSpan="10" style={{ fontWeight: "bold", textAlign: "center" }}>
     <span className="style">Indicators Performance Mapping Acceptance Entry Report</span> <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
    </th>
          </tr>
         <tr className="text-center only-export"> 

    <th colSpan="10" style={{ textAlign: "center", fontWeight: "bold" }}>
      {["119","116"].includes(roleid) ? (
        formik.values.type === 1 ? (
          <>
            District: {distlist.find(m => m.id === formik.values.district_id)?.value || "-"}
          </>
        ) : (
          <>
            District: {distlist.find(m => m.id === formik.values.district_id)?.value || "-"}
            &nbsp;&nbsp; | &nbsp;&nbsp; 
            Mandal: {mandalList.find(m => m.id === formik.values.mandal_id)?.value || "-"}
          </>
        )
      ) : selectedmandal ? (
        <>
          District: {selecteddist} &nbsp;&nbsp; | &nbsp;&nbsp; Mandal: {selectedmandal}
        </>
      ) : null}
    </th>
  </tr>

                        <tr className="text-center">
                          <th style={{headerStyle, width: "100px"}} >Sl.No.</th>
                          {["116"].includes(roleid) &&  formik.values.district_id==="0"  && (  
                             <th style={{headerStyle, width: "100px"}} >District</th>)}
                          {["119","116"].includes(roleid) &&  formik.values.mandal_id==="0" &&  formik.values.type===0 && (  
                             <th style={{headerStyle, width: "100px"}} >Mandal</th>)}
                          <th style={{headerStyle, width: "200px"}} >Indicator Type</th>
                        <th style={{ ...headerStyle, width: "200px" }} > Indicator </th>
                          {/* <th style={{headerStyle , width: "300px" }} >Targets</th>

                          <th style={headerStyle} >Contribution (%)</th> */}
                        </tr>

                        
                      </thead>

       
<tbody>
  {filteredData?.length === 0 || filteredData?.length === undefined ? (
    <tr>
      <td className="text-center" colSpan="15">
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    (() => {
      let mandalTracker = {};
     let districtTracker = {};

      return filteredData.map((detail, i) => {
        const mandal = detail.mandal_name;
        const district = detail.district_name;

        if (!districtTracker[district]) {
          let count = 0;

          for (let j = i; j < filteredData.length; j++) {
            if (filteredData[j].district_name === district) count++;
            else break;
          }

          districtTracker[district] = {
            count,
            rendered: false
          };
        }


        if (!mandalTracker[mandal]) {
          let count = 0;

          for (let j = i; j < filteredData.length; j++) {
            if (filteredData[j].mandal_name === mandal) count++;
            else break;
          }

          mandalTracker[mandal] = {
            count,
            rendered: false
          };
        }

        return (
          <tr key={i}>
            <td style={{ textAlign: "center" }}>{i + 1}</td>
               {["116"].includes(roleid) &&
              formik.values.district_id === "0" &&
              !districtTracker[district].rendered && (
                <td
                  rowSpan={districtTracker[district].count}
                  style={{ textAlign: "left", verticalAlign: "top" }}
                >
                  {district}
                </td>
              )}

            {districtTracker[district].rendered = true}


            {["119", "116"].includes(roleid) && formik.values.mandal_id === "0" && formik.values.type === 0 &&
              !mandalTracker[mandal].rendered && (
                <td
                  rowSpan={mandalTracker[mandal].count}
                  style={{ textAlign: "left", verticalAlign: "top" }}
                >
                  {mandal}
                </td>
              )}

            {mandalTracker[mandal].rendered = true}

            <td style={{ textAlign: "left" }}>
              {detail.cs_indicator_type}
            </td>

            <td style={{ textAlign: "left", width: "350px" }}>
              {detail.cs_indicator_name}
            </td>
              {/* <td style={{textAlign:"right"}}>{detail.targets}</td> 
              <td style={{textAlign:"right"}}>{detail.contribution_percentage}</td>  */}
          </tr> ); }); })() )}
  
  </tbody>

        </Table>
       
        </div> </div> </>
  )
)}

   

     



    


       </Container>
               
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
